import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/stock-valuation/report')({});
